// loading
export const LOADING = 'LOADING';
export const UNLOADING = 'UNLOADING';

// auth
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export const REFRESH_TOKEN_LOGIN_SUCCESS = 'REFRESH_TOKEN_LOGIN_SUCCESS';
export const REFRESH_TOKEN_LOGIN_FAILURE = 'REFRESH_TOKEN_LOGIN_FAILURE';
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS';
export const UPDATE_PASSWORD_FAILURE = 'UPDATE_PASSWORD_FAILURE';
export const CLEAR_UPDATE_PASSWORD_RESULT_FLG = 'CLEAR_UPDATE_PASSWORD_RESULT_FLG';
export const LOGOUT = 'LOGOUT';

// transaction
export const GET_TRANSACTION_LIST_SUCCESS = 'GET_TRANSACTION_LIST_SUCCESS';
export const GET_TRANSACTION_LIST_FAILURE = 'GET_TRANSACTION_LIST_FAILURE';
export const GET_ALL_TRANSACTION_LIST_SUCCESS = 'GET_ALL_TRANSACTION_LIST_SUCCESS';
export const GET_ALL_TRANSACTION_LIST_FAILURE = 'GET_ALL_TRANSACTION_LIST_FAILURE';
export const REFUND_SUCCESS = 'REFUND_SUCCESS';
export const REFUND_FAILURE = 'REFUND_FAILURE';
export const CLEAR_REFUND_RESULT_FLG = 'CLEAR_REFUND_RESULT_FLG';

// processing
export const UPLOAD_CSV_SUCCESS = 'UPLOAD_CSV_SUCCESS';
export const UPLOAD_CSV_FAILURE = 'UPLOAD_CSV_FAILURE';
export const CLEAR_UPLOAD_CSV_RESULT_FLG = 'CLEAR_UPLOAD_CSV_RESULT_FLG';

// customer
export const GET_CUSTOMER_LIST_SUCCESS = 'GET_CUSTOMER_LIST_SUCCESS';
export const GET_CUSTOMER_LIST_FAILURE = 'GET_CUSTOMER_LIST_FAILURE';
